<script lang="ts">
    import { ExportTypes } from '../../Export/ExportTypes';
    import IconDownload from '../../../shared/Icons/IconDownload.svelte';
    import { ExportType } from '../../Export/ExportType';
    import { ExportApi } from '../../Export/ExportApi';
    import { captureMessage } from '@sentry/svelte';
    import { api } from '../../../../stores/api';
    import { _ } from 'svelte-i18n';
    import IconPending from '../../../shared/Icons/IconPending.svelte';
    import { debug, planning } from '../../../../stores/store';
    import LinkSmallBlack from '../../../shared/LinkSmallBlack.svelte';
    import { app } from '../../../../stores/app';

    export let scenarioId: number | null = null;

    let downloadingInProgress: boolean = false;
    let et: ExportType = new ExportType('planning_export', 'planning_export');

    async function download(et: ExportType, scenarioId: number) {
        downloadingInProgress = true;
        // https://www.programonaut.com/how-to-create-a-download-for-a-zip-file-with-sveltekit-step-by-step/
        let exportFile = await ExportApi.getFile($api, et.getApiEndpoint(), {
            type: et.getType().long,
            import_id: scenarioId,
        }).catch(error => {
            console.error('Error downloading file', error);
            alert($_('error_downloading_file'));
            captureMessage('Error downloading file', {
                extra: {
                    error,
                },
            });
        });

        if (!exportFile) {
            downloadingInProgress = false;
            return;
        }

        // convert exportFile (raw csv file) to blob
        let blob = new Blob([exportFile], { type: et.getType().long });

        let url = window.URL || window.webkitURL;
        let link = url.createObjectURL(blob);

        // generate anchor tag, click it for download and then remove it again
        let a = document.createElement('a');
        a.setAttribute('download', et.getOutputFileName());
        a.setAttribute('href', link);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // revoke the object URL to free up memory
        url.revokeObjectURL(link);
        downloadingInProgress = false;
    }

    let filename_base: string =
        'lastmile_planowanie_raport_c' +
        ($app.account?.getCustomerId() ?? '') +
        '_' +
        $planning.selectedDay;
</script>

<div style="display: flex; align-items: center; column-gap: 6px; overflow: hidden;">
    {#if downloadingInProgress}
        <IconPending scale={0.7} spin={true} />
    {:else}
        {#if $debug}
            <LinkSmallBlack
                text="CSV"
                on:click={async () => {
                    console.log('Download planning for scenario', scenarioId);
                    if (scenarioId === null) {
                        console.warn('No scenarioId, cannot download');
                        return;
                    }
                    et.setOutputFileName(filename_base + '.' + ExportTypes.CSV.short);
                    console.log('export', et.getApiEndpoint());
                    et.setType(ExportTypes.CSV);
                    await download(et, scenarioId);
                }}
            />
        {/if}
        <IconDownload
            hover="Pobierz XLSX"
            scale={0.7}
            disabled={scenarioId === null || downloadingInProgress}
            on:click={async () => {
                console.log('Download planning for scenario', scenarioId);
                if (scenarioId === null) {
                    console.warn('No scenarioId, cannot download');
                    return;
                }
                et.setOutputFileName(filename_base + '.' + ExportTypes.XLSX.short);
                console.log('export', et.getApiEndpoint());
                et.setType(ExportTypes.XLSX);
                await download(et, scenarioId);
            }}
        />
    {/if}
</div>
